import { render, staticRenderFns } from "./OverwriteProduct.vue?vue&type=template&id=062abe3c&"
import script from "./OverwriteProduct.vue?vue&type=script&lang=js&"
export * from "./OverwriteProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports